import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ImportTransitPayload {
  customerId: string;
  templateId: string;
  declarantId: string;
  userId: string;
  resetCustomsData: boolean;
  file: File;
}

export const useAdminImportTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ImportTransitPayload) => {
      const formData = new FormData();
      formData.append('file', payload.file);
      formData.append('customerId', payload.customerId);
      formData.append('templateId', payload.templateId);
      formData.append('declarantId', payload.declarantId);
      formData.append('userId', payload.userId);
      formData.append('resetCustomsData', `${payload.resetCustomsData}`);

      await request({
        path: 'admin/import-transit',
        method: 'POST',
        authenticate: true,
        dataObject: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['admin-transits'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Failed to import transit');
    },
  });
};
